import { useDispatch, useSelector } from "react-redux";
import { ApiStatus } from "../types/api/status";
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar";
import { changeStatusPreStudents, onFetchPreStudents, selectPreStudentState } from "../redux/slices/preStudentSlice";
import { PreStudentAPI } from "../apis/PreStudentAPI";

export const usePreStudentStore = () => {
  const dispatch = useDispatch();
  const {
    preStudents,
    statusPreStudents,
    editPreStudent,
    selectedPreStudent,
    openModal,
    isEdit,
  } = useSelector(selectPreStudentState);

  const getPreStudents = async () => {
    try {
      dispatch(changeStatusPreStudents(ApiStatus.FETCHING));
      const response = await PreStudentAPI.getPreStudents();
      if (!response?.status) {
        dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchPreStudents(detail));
      dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
    }
  };

  const getPreStudentsSearch = async (term) => {
    try {
      dispatch(changeStatusPreStudents(ApiStatus.FETCHING));
      const response = await PreStudentAPI.getPreStudentsSearch(term);
      if (!response?.status) {
        dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
        return CustomSnackbar("error", response.data.message || "");
      }
      const { detail } = response.data;
      dispatch(onFetchPreStudents(detail));
      dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
    } catch (error) {
      console.log(error);
      return dispatch(changeStatusPreStudents(ApiStatus.FETCHED));
    }
  };

  return {
    // states
    preStudents,
    statusPreStudents,
    editPreStudent,
    selectedPreStudent,
    openModal,
    isEdit,
    // actions
    getPreStudents,
    getPreStudentsSearch,
  };
};